@if (parentData && configForm) {
    <div class="column-formatting-form">
        <form [formGroup]="configForm" (ngSubmit)="closeGrid(configForm.value)">
            <div class="section column-name">
                <div class="subsection">
                    <div class="title">Column Name</div>

                    <div class="column-label">{{ parentData.label }}</div>
                </div>

                <div class="subsection">
                    <div class="radio-btn">
                        <input
                            #display_as_configured
                            id="display_as_configured"
                            name="showCustomName"
                            formControlName="showCustomName"
                            type="radio"
                            [attr.checked]="display_as_configured.checked ? 'checked' : null"
                            [value]=false
                            (change)="toggleCustomNameField()" />

                        <label for="display_as_configured">As Configured</label>
                    </div>

                    <div class="radio-btn">
                        <input
                            #display_as_custom
                            id="display_as_custom"
                            name="showCustomName"
                            formControlName="showCustomName"
                            type="radio"
                            [attr.checked]="display_as_custom.checked ? 'checked' : null"
                            [value]=true
                            (change)="toggleCustomNameField()" />

                        <label for="display_as_custom">Custom</label>
                    </div>

                    <div class="content">
                        <input
                            type="text"
                            name="displayname"
                            formControlName="customName"
                            placeholder="Display Name"
                            maxlength="40"
                            autocomplete="off"/>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="subsection">
                    <p class="title">Display Type</p>

                    <div class="custom-select">
                        <app-dropdown
                            name="displayType"
                            formControlName="displayType"
                            [options]="displayTypes"
                            (selectedChange)="onDisplayTypeChanged($event)">
                        </app-dropdown>
                    </div>
                </div>

                @if (currentDisplayType === 'date') {
                    <div class="subsection">
                        <p class="title">Date Format</p>

                        <div class="custom-select">
                            <app-dropdown
                                name="dateFormat"
                                formControlName="dateFormat"
                                [options]="dateFormats">
                            </app-dropdown>
                        </div>
                    </div>
                }

                @if (configForm.get('displayType')?.value === 'value') {
                    <div class="subsection">
                        <div class="title">Aggregation Type</div>

                        <div class="custom-select">
                            <app-dropdown
                                name="aggregationtype"
                                formControlName="aggregationType"
                                [options]="aggTypes">
                            </app-dropdown>
                        </div>
                    </div>

                    <div class="section empty">
                        <div class="subsection use-abs-val">
                            <cc-checkbox
                                ngDefaultControl
                                formControlName="useAbsVal"
                                [label]="'Display as Absolute Value'"
                                [value]="!!configForm.get('useAbsVal')?.value"
                                (valueChange)="configForm.get('useAbsVal')?.setValue($event)">
                            </cc-checkbox>
                        </div>

                        <div class="subsection is-ranked">
                            <cc-checkbox
                                ngDefaultControl
                                formControlName="isRanked"
                                [label]="'Convert to Ranked Column'"
                                [value]="!!configForm.get('isRanked')?.value"
                                (valueChange)="configForm.get('isRanked')?.setValue($event)">
                            </cc-checkbox>
                        </div>
                    </div>

                    @if (configForm.get('isRanked')?.value) {
                        <div class="section empty">
                            <div class="subsection">&nbsp;</div>

                            <div class="subsection">
                                <p class="title">Rank Order</p>

                                <div class="custom-select">
                                    <app-dropdown
                                        name="rankOrder"
                                        formControlName="rankOrder"
                                        [options]="rankOrders">
                                    </app-dropdown>
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>

            @if (configForm.get('displayType')?.value !== 'bar') {
                <div class="section general-formatting">
                    <p class="title">General Formatting</p>

                    <div class="subsection">
                        <p class="title">Font Style</p>

                        <div class="custom-select">
                            <app-dropdown
                                name="fontstyle"
                                formControlName="fontStyle"
                                [options]="fontStyles">
                            </app-dropdown>
                        </div>
                    </div>

                    @if (configForm.get('displayType')?.value === 'value' && !configForm.get('isRanked')?.value) {
                        <div class="subsection">
                            <p class="title">Format</p>

                            <div class="custom-select">
                                <app-dropdown
                                    name="numberFormat"
                                    formControlName="numberFormat"
                                    [options]="numberFormats">
                                </app-dropdown>
                            </div>
                        </div>
                    }

                    <div class="subsection">
                        <p class="title">Alignment</p>

                        <div class="custom-select">
                            <app-dropdown
                                name="alignment"
                                formControlName="alignment"
                                [options]="alignmentList">
                            </app-dropdown>
                        </div>
                    </div>

                    @if (configForm.get('displayType')?.value === 'value' && !configForm.get('isRanked')?.value) {
                        <div class="subsection">
                            <p class="title">Decimal Places</p>

                            <input type="number" min="0" name="decimal" formControlName="decimalPlaces" />
                        </div>

                        <div class="section empty">
                            <div class="subsection">
                                <p class="title">Negative Values</p>

                                <div class="custom-select">
                                    <app-dropdown
                                        class="{{configForm.get('negativeValue')?.value}} {{configForm.get('negativeValue')?.value!.startsWith('red') ? 'redcolor' : ''}}"
                                        name="negative"
                                        formControlName="negativeValue"
                                        [options]="negativeValues">
                                    </app-dropdown>
                                </div>
                            </div>

                            <div class="subsection">
                                <p class="title">&nbsp;</p>

                                <cc-checkbox
                                    ngDefaultControl
                                    formControlName="isBlank"
                                    [label]="'Format Zeros as Blank Cells'"
                                    [value]="!!configForm.get('isBlank')?.value"
                                    (valueChange)="configForm.get('isBlank')?.setValue($event)">
                                </cc-checkbox>
                            </div>
                        </div>
                    }
                </div>
            }

            <div class="section url-widget">
                <div class="subsection">
                    <p class="title">Link Behavior</p>

                    <div class="custom-select">
                        <app-dropdown
                            name="linkBehavior"
                            formControlName="linkBehavior"
                            [options]="linkBehaviorFiltered"
                            [selected]="linkBehaviorSelected"
                            (selectedChange)="updateLinks($event)">
                        </app-dropdown>
                    </div>
                </div>

                <div class="subsection">
                    <p class="title">Link Type</p>

                    <div class="custom-select">
                        <app-dropdown
                            name="linkType"
                            formControlName="linkType"
                            [options]="linkTypeFiltered"
                            [selected]="linkTypeSelected"
                            (selectedChange)="updateLinks($event)">
                        </app-dropdown>
                    </div>
                </div>

                @if (configForm.get('linkType')?.value === 'url' && parentData.value !== 'instrumentId') {
                    <div class="subsection full-length column-hyperlink">
                        <p class="title">HYPERLINK</p>

                        <div class="custom-select">
                            <input
                                type="url"
                                name="hyperlink"
                                formControlName="hyperlink"
                                placeholder="Add Hyperlink To Column"
                                autocomplete="off"
                                (focusout)="validateUrl()"
                                [ngClass]="{'has-error': configForm.get('hyperlink')?.invalid && touchedOrDirty('hyperlink')}"/>
                        </div>

                        @if (configForm.get('hyperlink')?.hasError('urlIncorrect') && touchedOrDirty('hyperlink')) {
                            <div class="error-message">
                                Hyperlink is not valid!
                            </div>
                        }
                    </div>
                }

                @if (configForm.get('linkType')?.value === 'ddvwidget') {
                    <div class="subsection full-length column-ddvwidget">
                        <p class="title">DDV WIDGET</p>

                        <div class="custom-select">
                            <app-dropdown
                                name="ddvWidgets"
                                formControlName="ddvWidget"
                                [options]="ddvWidgets">
                            </app-dropdown>
                        </div>

                        @if (configForm.get('ddvWidget')?.hasError('ddvWidgetInvalid')) {
                            <div class="error-message">
                                Please choose a DDV widget or change the Link Type
                            </div>
                        }
                    </div>
                }
            </div>

            <ddv-conditional-formatting
                class="section conditional-formatting"
                [displayType]="configForm.get('displayType')?.value"
                [columnConditions]="configForm.get('columnCondition')?.value || []"
                [valueOperators]="valueOperators"
                (columnConditionChange)="onColumnConditionChange($event)"
            >
            </ddv-conditional-formatting>

            <div class="save-cancel">
                <button class="empty-btn" type="button" (click)="modalDialogActive.close('cancel')">Cancel</button>

                <button class="fill-btn" type="submit" [disabled]="!configForm.valid">Apply</button>
            </div>
        </form>
    </div>
}
